import {Component, OnInit} from '@angular/core';
import {ActiveUserService} from "../../services/active-user.service";
import {SnackbarService} from "../../services/snackbar.service";
import {IApiErrorResponse} from "../../interfaces/error/IApiErrorResponse";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {ITestEmails} from "../../interfaces/ITestEmails";
import {EmailTestingService} from "../../services/email-testing.service";
import {MatButton} from "@angular/material/button";
import {SentryTestingService} from "../../services/sentry-testing.service";
import {ITestSentryException} from "../../interfaces/ITestSentryException";
import {
  ColComponent,
  ContainerComponent,
  ListGroupDirective,
  ListGroupItemDirective,
  RowComponent
} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {TestingPageScreenState} from "../../enum/TestingPageScreenState";
import {MatFormField} from "@angular/material/form-field";
import {MatOption, MatSelect, MatSelectChange} from "@angular/material/select";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {IEmailTemplateType} from "../../interfaces/IEmailTemplateType";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-testing-page',
  standalone: true,
  templateUrl: './testing-page.component.html',
  imports: [
    MatButton,
    ContainerComponent,
    ChooseYourGameComponent,
    RowComponent,
    ColComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    MatFormField,
    MatSelect,
    MatOption,
    ReactiveFormsModule,
    MatProgressSpinner
  ],
  styleUrls: ['./testing-page.component.css']
})
export class TestingPageComponent implements OnInit{
  public activeAdmin = this.activeUserService.activeUser();
  public activeGame: IGameQueryResult | null = null;

  public currentScreenState = TestingPageScreenState.SendEmails;
  public screenState = TestingPageScreenState;
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  public emailTemplateTypes : IEmailTemplateType[] = [];

  public templateControl = new FormControl<number[] | null>(null);

  public emailForm = new FormGroup({
    template: this.templateControl
  });

  constructor(private emailTestingService: EmailTestingService,
              private activeUserService: ActiveUserService,
              private snackBarService: SnackbarService,
              private errorHandlingService: ErrorHandlingService,
              private sentryTestingService: SentryTestingService) {
  }

  ngOnInit() {
    this.uiState = UIStateEnum.ShowLoading;
    this.emailTestingService.getEmailTemplateTypes().subscribe({
      next: (result) => {
        this.uiState = UIStateEnum.ShowData;
        this.emailTemplateTypes = result;
      },
      error: (error) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to fetch email templates");
      }
    })
  }

  onGameChange(gameP: IGameQueryResult) {
    this.activeGame = gameP;
  }

  public generateTestEmails() {
    this.uiState = UIStateEnum.ShowLoading;
    const testEmailsRequest: ITestEmails = {
      AdminId: this.activeAdmin.Id,
      GameId: this.activeGame?.Id!,
      TemplateIds: this.templateControl.value!
    };

    this.emailTestingService.sendTestEmails(testEmailsRequest).subscribe({
        next: () => {
          this.uiState = UIStateEnum.ShowData;
          this.snackBarService.openSuccessfulSnackBar('Emails were successfully sent');
        },
        error: (res: IApiErrorResponse) => {
          this.uiState = UIStateEnum.ShowData;
          if (res.Error?.ClientErrorMessages?.length > 0) {
            this.errorHandlingService.displayPageLevelErrorMessage(res, res.Error.ClientErrorMessages.toString())
          } else {
            this.errorHandlingService.displayPageLevelErrorMessage(res);
          }
        }
      }
    )
  }

  public testSentryException() {
    const sentryExceptionRequest: ITestSentryException = {
      AdminId: this.activeAdmin.Id,
      GameId: this.activeGame?.Id!
    }

    this.sentryTestingService.throwSentryException(sentryExceptionRequest).subscribe({
        next: () => {
          this.snackBarService.openSuccessfulSnackBar('Causable API - Test Sentry Exception successfully thrown');
        },
        error: (res: IApiErrorResponse) => {
          if (res.Error?.ClientErrorMessages?.length > 0) {
            this.errorHandlingService.displayPageLevelErrorMessage(res, res.Error.ClientErrorMessages.toString())
          } else {
            this.errorHandlingService.displayPageLevelErrorMessage(res);
          }
        }
      }
    )
  }

  onSelect($event: MatSelectChange) {
    if ($event.value.includes(undefined)) {
      this.templateControl.setValue([]);
    }
  }
}
